import React from 'react';
import AppTrain from '../../../../../../../resources/images/png/mobileAppTrain.png';
import MobileApp from '../../../../../../../resources/images/png/mobileApp.png';
import { ReactComponent as DownloadIos } from '../../../../../../../resources/images/svg/downloadIos.svg';
import { ReactComponent as DownloadAndroid } from '../../../../../../../resources/images/svg/downloadAndroid.svg';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

function MobileAppAdvertisement() {
  const { trans } = useTranslation();
  return (
    <div className="flex lg:hidden relative container h-[550px] justify-center items-end">
      <img className="absolute z-[1] top-0 left-20 translate-x-[-50%] w-screen" src={AppTrain} alt="train" height={270} />
      <div className="absolute z-[2] left-0 bg-primary w-screen h-[319px] rounded-l-3xl flex flex-col justify-end gap-5 pl-[25px] pr-5 pb-[25px]">
        <div className="relative overflow-x-clip w-full">
          <img className="absolute z-[2] bottom-0 2xs:left-0 xs:right-0 translate-x-10" src={MobileApp} alt="mobile app" height={297} />
        </div>
        <p className="m-0 text-white text-base phone:text-xs max-w-[324px]">
          {trans('download-application')}
        </p>
        <div className="flex gap-4 max-w-[324px]">
          <DownloadIos />
          <DownloadAndroid />
        </div>
      </div>
    </div>
  );
}

export default MobileAppAdvertisement;
